<template>
    <div>
        <el-form :inline="true" :model="queryParams"  class="demo-form-inline" size="small" style="text-align: left;margin-top: 5px">
            <el-form-item label="订单号">
                <el-input v-model="queryParams.orderId" placeholder="请输入订单号查询" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="queryParams.orderPhone" placeholder="请输入手机号查询" clearable></el-input>
            </el-form-item>
            <el-form-item label="所属学校">
                <el-select v-model="queryParams.schoolId" placeholder="请选择学校" :clearable="!schoolLocked" :disabled="schoolLocked">
                    <el-option
                            v-for="item in schoolList"
                            :key="item.schoolId"
                            :label="item.schoolName"
                            :value="item.schoolId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单时间">
                <el-date-picker
                        v-model="orderTime"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" size="mini" @click="getCategoryList()">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery()">重置</el-button>
                <el-button
                        type="success"
                        size="mini"
                        icon="el-icon-download"
                        :loading="exportLoading"
                        @click="exportReport">
                    导出报表
                </el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" size="mini" icon="el-icon-magic-stick" @click="openVirtualDialog">添加虚拟订单</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="list"
                style="width: 100%">
            <el-table-column label="订单号" prop="orderId"/>
            <el-table-column label="订单状态" prop="status">
                <template slot-scope="scope">
                    <el-button style="margin-left: 12px;background:black;" type="warning" size="mini" round v-if="scope.row.status=='0'">未接单</el-button>
                    <el-button style="margin-left: 12px" type="success" size="mini" round v-if="scope.row.status=='1'">派送中</el-button>
                    <el-button style="margin-left: 12px;background:#72121B;" type="warning" size="mini" round v-if="scope.row.status=='2'">已送达</el-button>
                    <el-button style="margin-left: 12px" type="info" size="mini" round v-if="scope.row.status=='3'">已完成</el-button>
                    <el-button style="margin-left: 12px" type="warning" size="mini" round v-if="scope.row.status=='4'">售后</el-button>
                    <el-button style="margin-left: 12px" type="danger" size="mini" round v-if="scope.row.status=='5'">已退款</el-button>
                    <el-button style="margin-left: 12px;background: #df5000" type="warning" size="mini" round v-if="scope.row.status=='6'">驳回退款</el-button>
                </template>
            </el-table-column>
            <el-table-column label="下单人姓名" prop="nickName"/>
            <el-table-column label="手机号" prop="phone"/>
            <el-table-column label="学校" prop="schoolName"/>
            <el-table-column label="下单时间" prop="createTime">
                <template slot-scope="scope">
                    <span>{{ scope.row.createTime | dateFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column label="实收金额" prop="orderPrice">
                <template slot-scope="scope">
                    <span>￥{{ scope.row.orderPrice.toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right">
                <template slot-scope="scope">
                    <el-button
                            @click.native.prevent="details(scope.row)"
                            type="text"
                            size="small" style="color: orange">
                        查看
                    </el-button>
                    <el-button
                            @click.native.prevent="deleteRow(scope.row.id)"
                            type="text"
                            size="small"  style="color: #ff042b">
                        移除
                    </el-button>
                    <el-button
                            @click.native.prevent="updateStatus(scope.row.id)"
                            type="text"
                            size="small" style="color: var(--primary-color)" v-if="type==4">
                        点击完成
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <template v-if="list.length!=0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.pageNum" :page-sizes="[1, 2, 5, 10]"
                           :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </template>

        <el-dialog title="订单详情" :visible.sync="outerVisible" width="40%">
            <el-descriptions class="margin-top" :column="2">
                <el-descriptions-item label="订单号">{{orderDetail.orderId}}
                    <el-button style="margin-left: 12px;background:black;" type="warning" size="mini" round v-if="orderDetail.status=='0'">未接单</el-button>
                    <el-button style="margin-left: 12px" type="success" size="mini" round v-if="orderDetail.status=='1'">派送中</el-button>
                    <el-button style="margin-left: 12px" size="mini" round v-if="orderDetail.status=='2'">已送达</el-button>
                    <el-button style="margin-left: 12px" type="info" size="mini" round v-if="orderDetail.status=='3'">已完成</el-button>
                    <el-button style="margin-left: 12px" type="warning" size="mini" round v-if="orderDetail.status=='4'">售后</el-button>
                    <el-button style="margin-left: 12px" type="danger" size="mini" round v-if="orderDetail.status=='5'">已退款</el-button>
                    <el-button style="margin-left: 12px;color: #df5000" size="mini" round v-if="orderDetail.status=='6'">驳回退款</el-button>
                </el-descriptions-item>
                <el-descriptions-item label="下单时间">{{orderDetail.createTime | dateFormat}}</el-descriptions-item>
            </el-descriptions>
            <el-divider></el-divider>
            <el-descriptions class="margin-top" :column="2">
                <el-descriptions-item label="用户名">{{orderDetail.nickName}}</el-descriptions-item>
                <el-descriptions-item label="手机号">{{orderDetail.phone}}</el-descriptions-item>
                <el-descriptions-item label="下单学校">{{orderDetail.schoolName}}</el-descriptions-item>
                <el-descriptions-item label="预计送达时间">{{ orderDetail.expectTime | dateFormat }}</el-descriptions-item>
                <el-descriptions-item label="收货地址">{{orderDetail.addressName}}</el-descriptions-item>
                <el-descriptions-item label="取货地址" v-if="orderDetail.paddressName!=null">{{orderDetail.paddressName}}</el-descriptions-item>
            </el-descriptions>
            
            <!-- 加价记录 -->
            <template v-if="priceIncreaseList && priceIncreaseList.length > 0">
                <el-divider></el-divider>
                <el-descriptions class="margin-top" :column="1" :style="{border: '1px solid #E1F3F0', borderRadius: '4px', padding: '12px', background: '#F0FDFA'}">
                    <el-descriptions-item label="加价记录" :span="1">
                        <div v-for="(item, index) in priceIncreaseList" :key="item.id" style="margin-bottom: 12px;">
                            <el-tag size="small" type="success" style="margin-right: 8px;">第{{index + 1}}次</el-tag>
                            <span style="color: #00C2A8; font-weight: 600; font-size: 16px;">+¥{{item.increaseAmount}}</span>
                            <span style="color: #909399; margin-left: 12px; font-size: 13px;">{{item.createTime | dateFormat}}</span>
                            <el-tag v-if="item.paymentStatus == '1'" size="mini" type="success" style="margin-left: 8px;">已支付</el-tag>
                            <el-tag v-else-if="item.paymentStatus == '0'" size="mini" type="warning" style="margin-left: 8px;">待支付</el-tag>
                            <el-tag v-else size="mini" type="danger" style="margin-left: 8px;">支付失败</el-tag>
                            <div v-if="item.increaseReason" style="color: #606266; font-size: 13px; margin-top: 4px; margin-left: 70px;">
                                原因：{{item.increaseReason}}
                            </div>
                        </div>
                        <div style="margin-top: 12px; padding-top: 12px; border-top: 1px dashed #DCDFE6;">
                            <span style="color: #303133; font-weight: 600;">累计加价：</span>
                            <span style="color: #00C2A8; font-weight: 700; font-size: 18px;">¥{{totalIncreaseAmount}}</span>
                            <span style="color: #909399; margin-left: 16px; font-size: 13px;">（共{{priceIncreaseList.length}}次）</span>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </template>
            
            <el-input placeholder="备注信息" v-model="orderDetail.remark" disabled>
                <template slot="prepend">备注</template>
                <i
                        class="el-icon-edit el-input__icon"
                        slot="suffix">
                </i>
            </el-input>
            <template v-if="orderDetail.status!=0 && orderDetail.jobName">
                <el-divider></el-divider>
                <el-descriptions class="margin-top" :column="2" :style="{border: '1px solid #EBEEF5', borderRadius: '4px', padding: '12px', background: '#F5F7FA'}">
                    <el-descriptions-item label="接单人" :span="2">
                        <span style="font-weight: 600; color: #303133;">{{orderDetail.jobName}}</span>
                        <el-tag v-if="orderDetail.jobType == 'F'" size="mini" type="warning" style="margin-left: 8px;">负责人</el-tag>
                        <el-tag v-else-if="orderDetail.jobType == 'C'" size="mini" type="success" style="margin-left: 8px;">兼职</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="联系电话">
                        <span style="color: #606266;">{{orderDetail.jobPhone}}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="接单时间">
                        <span style="color: #606266;">{{orderDetail.updateTime | dateFormat}}</span>
                    </el-descriptions-item>
                </el-descriptions>
            </template>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="2">
                    订单
                </el-col>
                <el-col :span="22">
                    <el-descriptions class="margin-top" :column="2">
                        <el-descriptions-item label="类型">{{orderDetail.orderType}}</el-descriptions-item>
                        <el-descriptions-item label="内容">{{orderDetail.orderContent}}</el-descriptions-item>
                    </el-descriptions>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="2">
                    费用
                </el-col>
                <el-col :span="22">
                    <el-descriptions class="margin-top" :column="2">
                        <el-descriptions-item label="派送费">￥{{orderDetail.orderPrice}}</el-descriptions-item>
                        <el-descriptions-item label="共计"><span style="color: red">￥{{orderDetail.orderPrice}}</span></el-descriptions-item>
                        <el-descriptions-item label="支付渠道">{{orderDetail.paymentChannels}}</el-descriptions-item>
                        <el-descriptions-item label="支付时间">{{orderDetail.createTime | dateFormat}}</el-descriptions-item>
                    </el-descriptions>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeOrderDetail" style="background:#103D69;color: white">取 消</el-button>
                <el-button 
                    v-if="orderDetail.status=='1'" 
                    type="warning" 
                    icon="el-icon-s-promotion" 
                    @click="openTransferDialog">
                    转派订单
                </el-button>
                <el-button type="primary" @click="openIncomeDialog" style="background:#00C2A8;border-color:#00C2A8;">数据中心</el-button>
            </div>
        </el-dialog>

        <!-- 转派订单对话框 -->
        <el-dialog title="转派订单" :visible.sync="transferDialogVisible" width="600px" append-to-body @close="resetTransferForm">
            <el-alert
                title="提示"
                type="info"
                :closable="false"
                style="margin-bottom: 20px;">
                只能将订单转派给同一学校的其他负责人或兼职人员
            </el-alert>

            <el-form :model="transferForm" :rules="transferRules" ref="transferForm" label-width="100px">
                <el-form-item label="当前订单">
                    <el-input v-model="transferForm.orderId" disabled>
                        <template slot="prepend">订单号</template>
                    </el-input>
                </el-form-item>

                <el-form-item label="当前接单人">
                    <el-input v-model="transferForm.currentJobName" disabled>
                        <template slot="append">{{transferForm.currentJobPhone}}</template>
                    </el-input>
                </el-form-item>

                <el-form-item label="学校">
                    <el-input v-model="transferForm.schoolName" disabled></el-input>
                </el-form-item>

                <el-form-item label="选择负责人" prop="toUserId">
                    <el-select 
                        v-model="transferForm.toUserId" 
                        placeholder="请选择要转派的负责人或兼职" 
                        filterable
                        clearable
                        style="width: 100%"
                        @change="handleTransferUserChange">
                        <el-option-group label="负责人" v-if="managerList.length > 0">
                            <el-option
                                v-for="manager in managerList"
                                :key="'manager-' + manager.id"
                                :label="manager.jobName + ' (' + manager.jobPhone + ')'"
                                :value="manager.campusUserId"
                                :disabled="manager.campusUserId == transferForm.fromUserId">
                                <span style="float: left">{{ manager.jobName }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ manager.jobPhone }}</span>
                            </el-option>
                        </el-option-group>
                        <el-option-group label="兼职人员" v-if="runnerList.length > 0">
                            <el-option
                                v-for="runner in runnerList"
                                :key="'runner-' + runner.id"
                                :label="runner.jobName + ' (' + runner.jobPhone + ')'"
                                :value="runner.campusUserId"
                                :disabled="runner.campusUserId == transferForm.fromUserId">
                                <span style="float: left">{{ runner.jobName }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ runner.jobPhone }}</span>
                            </el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>

                <el-form-item label="转派原因">
                    <el-input 
                        type="textarea" 
                        :rows="3" 
                        v-model="transferForm.reason" 
                        placeholder="请输入转派原因（可选）"
                        maxlength="200"
                        show-word-limit>
                    </el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="transferDialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="transferSubmitting" @click="handleTransferSubmit">确认转派</el-button>
            </div>
        </el-dialog>

        <!-- 数据中心 - 收入统计对话框 -->
        <el-dialog title="数据中心 - 收入统计" :visible.sync="innerVisible" width="60%" append-to-body>
            <el-tabs v-model="activeTab" type="card">
                <el-tab-pane label="兼职收入排行" name="parttime">
                    <el-table :data="parttimeIncomeList" style="width: 100%" v-loading="loading">
                        <el-table-column type="index" label="排名" width="80" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.$index === 0" type="danger" size="medium">🥇 {{scope.$index + 1}}</el-tag>
                                <el-tag v-else-if="scope.$index === 1" type="warning" size="medium">🥈 {{scope.$index + 1}}</el-tag>
                                <el-tag v-else-if="scope.$index === 2" type="success" size="medium">🥉 {{scope.$index + 1}}</el-tag>
                                <span v-else>{{scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" label="负责人/团队" min-width="150"/>
                        <el-table-column prop="schoolName" label="所属学校" min-width="120"/>
                        <el-table-column prop="income" label="总收入" min-width="120" align="right">
                            <template slot-scope="scope">
                                <span style="color: #00C2A8; font-weight: 600;">￥{{ scope.row.income.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                
                <el-tab-pane label="平台收入排行" name="platform">
                    <el-table :data="platformIncomeList" style="width: 100%" v-loading="loading">
                        <el-table-column type="index" label="排名" width="80" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.$index === 0" type="danger" size="medium">🥇 {{scope.$index + 1}}</el-tag>
                                <el-tag v-else-if="scope.$index === 1" type="warning" size="medium">🥈 {{scope.$index + 1}}</el-tag>
                                <el-tag v-else-if="scope.$index === 2" type="success" size="medium">🥉 {{scope.$index + 1}}</el-tag>
                                <span v-else>{{scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" label="负责人/团队" min-width="150"/>
                        <el-table-column prop="schoolName" label="所属学校" min-width="120"/>
                        <el-table-column prop="income" label="总收入" min-width="120" align="right">
                            <template slot-scope="scope">
                                <span style="color: #FF7A5C; font-weight: 600;">￥{{ scope.row.income.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click="innerVisible = false">关 闭</el-button>
                <el-button type="primary" @click="refreshIncomeData" style="background:#00C2A8;border-color:#00C2A8;">
                    <i class="el-icon-refresh"></i> 刷新数据
                </el-button>
            </div>
        </el-dialog>

        <!-- 添加虚拟订单 -->
        <el-dialog title="添加虚拟订单" :visible.sync="virtualDialogVisible" width="1000px" @close="resetVirtualForm">
            <el-form :model="virtualForm" :rules="virtualRules" ref="virtualForm" label-width="100px">
                <el-row :gutter="30">
                    <!-- 左列 -->
                    <el-col :span="12">
                        <el-form-item label="所属学校" prop="schoolId">
                            <el-select v-model="virtualForm.schoolId" placeholder="请选择学校" filterable :clearable="!schoolLocked" :disabled="schoolLocked" @change="handleSchoolChange" style="width: 100%">
                                <el-option v-for="item in schoolList" :key="item.schoolId" :label="item.schoolName" :value="item.schoolId"></el-option>
                            </el-select>
                        </el-form-item>
                        
                        <el-form-item label="用户昵称" prop="nickName">
                            <el-input v-model="virtualForm.nickName" maxlength="12" placeholder="请输入昵称"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="订单类型" prop="orderType">
                            <el-select v-model="virtualForm.orderType" placeholder="请选择订单类型" style="width: 100%">
                                <el-option v-for="item in orderTypeOptions" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        
                        <el-form-item label="订单金额" prop="orderPrice">
                            <el-input-number v-model="virtualForm.orderPrice" :min="2.5" :step="0.5" controls-position="right" style="width: 100%"></el-input-number>
                            <div class="tips-text">单位：元</div>
                        </el-form-item>
                        
                        <el-form-item label="订单内容" prop="orderContent">
                            <el-input type="textarea" :rows="3" v-model="virtualForm.orderContent" maxlength="180" show-word-limit placeholder="请输入任务描述"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="收货地址" prop="addressName">
                            <el-input v-model="virtualForm.addressName" placeholder="例如：北区 5 栋 302"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="取货地址">
                            <el-input v-model="virtualForm.pickupAddressName" placeholder="可选，驿站或其他地点"></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <!-- 右列 -->
                    <el-col :span="12">
                        <el-form-item label="联系方式">
                            <el-input v-model="virtualForm.phone" maxlength="11" placeholder="可选，默认生成"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="预约时间">
                            <el-checkbox v-model="virtualForm.noReservation" @change="handleNoReservationChange">该订单不需要预约时间</el-checkbox>
                        </el-form-item>
                        
                        <el-form-item label="预约日期" v-if="!virtualForm.noReservation">
                            <el-radio-group v-model="selectedReservationDay" @change="handleReservationDayChange" size="small">
                                <el-radio-button v-for="day in reservationDays" :key="day.key" :label="day.key" :disabled="day.disabled">{{ day.label }}</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        
                        <el-form-item label="时间段" v-if="!virtualForm.noReservation">
                            <el-select v-model="virtualForm.reservedTime" placeholder="请选择时间段" :disabled="timeSlotOptions.length===0" style="width: 100%">
                                <el-option v-for="slot in timeSlotOptions" :key="slot.value" :label="slot.label" :value="slot.value"></el-option>
                            </el-select>
                            <div class="tips-text" v-if="!timeSlotOptions.length">当前日期暂无可选时间段</div>
                        </el-form-item>
                        
                        <el-form-item label="用户头像">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :headers="uploadHeaders"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                accept="image/*">
                                <img v-if="virtualForm.avatar" :src="virtualForm.avatar" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <div class="tips-text">支持JPG、PNG格式，大小不超过2MB</div>
                        </el-form-item>
                        
                        <el-form-item label="订单图片">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :headers="uploadHeaders"
                                :show-file-list="false"
                                :on-success="handleOrderImageSuccess"
                                :before-upload="beforeAvatarUpload"
                                accept="image/*">
                                <img v-if="virtualForm.orderImage" :src="virtualForm.orderImage" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <div class="tips-text">支持JPG、PNG格式，大小不超过2MB</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <!-- 备注单独占一行 -->
                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" v-model="virtualForm.remark" placeholder="例如：虚拟订单"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="virtualDialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="virtualSubmitting" @click="handleVirtualSubmit">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import moment from "moment";
    import { downloadReport } from "@/assets/js/reportDownload";
    import { isSchoolScoped, getBoundSchoolId, lockSchoolOptions } from "@/utils/schoolScope";
    export default {
        props:{
            type:Number
        },
        computed: {
            schoolLocked() {
                return isSchoolScoped();
            }
        },
        data() {
            const validateReservedTime = (rule, value, callback) => {
                if (this.virtualForm.noReservation) {
                    callback();
                } else if (!value) {
                    callback(new Error('请选择时间段'));
                } else {
                    callback();
                }
            };
            return {
                //图片上传配置
                uploadUrl: this.$http.defaults.baseURL + 'upload',
                uploadHeaders: {
                    'token': window.sessionStorage.getItem('token')
                },
                //学校列表
                schoolList:[],
                //订单详情
                orderDetail:{},
                //详情弹出框
                outerVisible:false,
                //加价记录列表
                priceIncreaseList: [],
                //累计加价金额
                totalIncreaseAmount: 0,
                //数据中心对话框
                innerVisible: false,
                //当前Tab
                activeTab: 'parttime',
                //加载状态
                loading: false,
                //兼职收入数据
                parttimeIncomeList: [],
                //平台收入数据
                platformIncomeList: [],
                //订单列表
                list:[],
                exportLoading: false,
                //时间选择
                orderTime:[],
                //查询数据
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    status:'',
                    orderId:'',
                    orderPhone:'',
                    schoolId:'',
                    beginTime:'',
                    endTime:'',
                },
                orderTypeOptions: ['代取快递','万能帮','代取外卖','跑腿打印','宿舍服务'],
                reservationDays: [],
                selectedReservationDay: '',
                timeSlotOptions: [],
                //多选
                selectedRows: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                virtualDialogVisible: false,
                virtualSubmitting: false,
                virtualForm: {
                    schoolId: '',
                    nickName: '',
                    orderType: '代取快递',
                    orderPrice: 3,
                    orderContent: '',
                    addressName: '',
                    pickupAddressName: '',
                    phone: '',
                    reservedDate: '',
                    reservedTime: '',
                    avatar: '',
                    orderImage: '',
                    orderDeliveryContent: '',
                    remark: '',
                    noReservation: false
                },
                virtualRules: {
                    schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
                    nickName: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
                    orderType: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
                    orderPrice: [{ required: true, message: '请输入金额', trigger: 'change' }],
                    orderContent: [{ required: true, message: '请输入订单内容', trigger: 'blur' }],
                    addressName: [{ required: true, message: '请输入收货地址', trigger: 'blur' }],
                    reservedTime: [{ validator: validateReservedTime, trigger: 'change' }]
                },
                // 转派订单相关
                transferDialogVisible: false,
                transferSubmitting: false,
                transferForm: {
                    orderId: '',
                    fromUserId: null,
                    toUserId: null,
                    currentJobName: '',
                    currentJobPhone: '',
                    schoolName: '',
                    schoolId: null,
                    reason: ''
                },
                transferRules: {
                    toUserId: [{ required: true, message: '请选择要转派的人员', trigger: 'change' }]
                },
                managerList: [], // 负责人列表
                runnerList: []   // 兼职人员列表
            }
        },
        mounted() {
            if (this.type==1){
                this.getCategoryList();//全部订单
            }else if (this.type==2){
                this.queryParams.status=0;//待接单
                this.getCategoryList();
            }else if (this.type==3){
                this.queryParams.status=1;//派送中
                this.getCategoryList();
            }else if (this.type==4){
                this.queryParams.status=2;//已送达
                this.getCategoryList();
            }else if (this.type==5){
                this.queryParams.status=3;//已完成
                this.getCategoryList();
            }else if (this.type==6){
                this.queryParams.status=4;//售后
                this.getCategoryList();
            }else if (this.type==7){
                this.queryParams.status=5;//已退款
                this.getCategoryList();
            }else if (this.type==8){
                this.queryParams.status=6;//退款驳回
                this.getCategoryList();
            }

            //获取学校列表
            this.getSchoolList();
        },
        methods: {
            //打开转派订单对话框
            async openTransferDialog() {
                if (!this.orderDetail.id || !this.orderDetail.schoolId) {
                    this.$message.error('订单信息不完整');
                    return;
                }

                // 设置转派表单数据
                this.transferForm.orderId = this.orderDetail.orderId;
                this.transferForm.fromUserId = this.orderDetail.jobUserId;
                this.transferForm.currentJobName = this.orderDetail.jobName;
                this.transferForm.currentJobPhone = this.orderDetail.jobPhone;
                this.transferForm.schoolName = this.orderDetail.schoolName;
                this.transferForm.schoolId = this.orderDetail.schoolId;
                this.transferForm.toUserId = null;
                this.transferForm.reason = '';

                // 获取该学校的负责人和兼职列表
                await this.loadSchoolStaff(this.orderDetail.schoolId);

                this.transferDialogVisible = true;
            },

            //加载学校的负责人和兼职人员列表
            async loadSchoolStaff(schoolId) {
                try {
                    // 获取负责人列表
                    const { data: res1 } = await this.$http.get('/campusjob/getManagersBySchool', {
                        params: { schoolId: schoolId }
                    });
                    if (res1.code === 200) {
                        this.managerList = res1.data || [];
                    }

                    // 获取兼职人员列表
                    const { data: res2 } = await this.$http.get('/campusjob/getRunnersBySchool', {
                        params: { schoolId: schoolId }
                    });
                    if (res2.code === 200) {
                        this.runnerList = res2.data || [];
                    }
                } catch (error) {
                    console.error('获取人员列表失败:', error);
                    this.$message.error('获取人员列表失败');
                }
            },

            //选择转派人员
            handleTransferUserChange(userId) {
                // 可以在这里添加额外的逻辑
                console.log('选择了用户:', userId);
            },

            //提交转派订单
            handleTransferSubmit() {
                this.$refs.transferForm.validate(async (valid) => {
                    if (!valid) {
                        return;
                    }

                    this.$confirm(`确认将订单 ${this.transferForm.orderId} 转派给选中的人员吗？`, '确认转派', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        this.transferSubmitting = true;
                        try {
                            const { data: res } = await this.$http.post('/campusorder/transferOrder', {
                                orderId: this.orderDetail.id,
                                fromUserId: this.transferForm.fromUserId,
                                toUserId: this.transferForm.toUserId
                            });

                            if (res.code === 200) {
                                this.$message.success('订单转派成功');
                                this.transferDialogVisible = false;
                                this.closeOrderDetail(); // 关闭订单详情并清空加价记录
                                this.getCategoryList(); // 刷新订单列表
                            } else {
                                this.$message.error(res.msg || '转派失败');
                            }
                        } catch (error) {
                            console.error('转派订单失败:', error);
                            this.$message.error('转派失败，请稍后重试');
                        } finally {
                            this.transferSubmitting = false;
                        }
                    }).catch(() => {
                        this.$message.info('已取消转派');
                    });
                });
            },

            //重置转派表单
            resetTransferForm() {
                if (this.$refs.transferForm) {
                    this.$refs.transferForm.resetFields();
                }
                this.transferForm = {
                    orderId: '',
                    fromUserId: null,
                    toUserId: null,
                    currentJobName: '',
                    currentJobPhone: '',
                    schoolName: '',
                    schoolId: null,
                    reason: ''
                };
                this.managerList = [];
                this.runnerList = [];
            },

            //头像上传成功回调
            handleAvatarSuccess(res, file) {
                if (res.code === 200) {
                    this.virtualForm.avatar = res.data;
                    this.$message.success('头像上传成功');
                } else {
                    this.$message.error(res.msg || '上传失败');
                }
            },
            
            //订单图片上传成功回调
            handleOrderImageSuccess(res, file) {
                if (res.code === 200) {
                    this.virtualForm.orderImage = res.data;
                    this.$message.success('图片上传成功');
                } else {
                    this.$message.error(res.msg || '上传失败');
                }
            },
            
            //图片上传前的校验
            beforeAvatarUpload(file) {
                const isImage = file.type.startsWith('image/');
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isImage) {
                    this.$message.error('只能上传图片文件!');
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                    return false;
                }
                return true;
            },
            
            //打开数据中心对话框
            async openIncomeDialog() {
                this.innerVisible = true;
                await this.loadIncomeData();
            },
            
            //加载收入数据
            async loadIncomeData() {
                this.loading = true;
                try {
                    // 获取兼职收入排行
                    const { data: res1 } = await this.$http.get('/init/getIncomeTotals');
                    if (res1.code === 200) {
                        this.parttimeIncomeList = res1.data || [];
                    }
                    
                    // 获取平台收入排行
                    const { data: res2 } = await this.$http.get('/init/getIncomeTotal');
                    if (res2.code === 200) {
                        this.platformIncomeList = res2.data || [];
                    }
                } catch (error) {
                    console.error('加载收入数据失败:', error);
                    this.$message.error('加载数据失败，请稍后重试');
                } finally {
                    this.loading = false;
                }
            },
            
            //刷新收入数据
            async refreshIncomeData() {
                this.$message.info('正在刷新数据...');
                await this.loadIncomeData();
                this.$message.success('数据刷新成功');
            },

            openVirtualDialog() {
                if (!this.schoolList || this.schoolList.length === 0) {
                    this.getSchoolList();
                }
                this.virtualForm.schoolId = this.queryParams.schoolId || '';
                this.virtualForm.noReservation = false;
                this.virtualDialogVisible = true;
                this.prepareReservationOptions();
            },

            resetVirtualForm() {
                if (this.$refs.virtualForm) {
                    this.$refs.virtualForm.resetFields();
                }
                this.virtualForm.orderType = this.orderTypeOptions[0];
                this.virtualForm.orderPrice = 3;
                this.virtualForm.noReservation = false;
                this.virtualForm.reservedDate = '';
                this.virtualForm.reservedTime = '';
                this.virtualForm.schoolId = '';
                this.reservationDays = [];
                this.selectedReservationDay = '';
                this.timeSlotOptions = [];
                this.virtualSubmitting = false;
            },

            handleVirtualSubmit() {
                this.$refs.virtualForm.validate(async (valid) => {
                    if (!valid) {
                        return;
                    }
                    if (!this.virtualForm.noReservation && !this.virtualForm.reservedDate) {
                        this.$message.error('请选择预约日期');
                        return;
                    }
                    this.virtualSubmitting = true;
                    try {
                        const payload = { ...this.virtualForm };
                        payload.nickName = payload.nickName.trim();
                        payload.orderType = payload.orderType.trim();
                        payload.orderContent = payload.orderContent.trim();
                        payload.addressName = payload.addressName ? payload.addressName.trim() : '';
                        payload.pickupAddressName = payload.pickupAddressName ? payload.pickupAddressName.trim() : '';
                        payload.remark = payload.remark ? payload.remark.trim() : '';
                        payload.orderPrice = Number(payload.orderPrice);
                        payload.reservedDate = this.virtualForm.noReservation ? null : payload.reservedDate;
                        payload.reservedTime = this.virtualForm.noReservation ? null : payload.reservedTime;
                        if (!payload.pickupAddressName) payload.pickupAddressName = null;
                        if (!payload.phone) payload.phone = null;
                        if (!payload.avatar) payload.avatar = null;
                        if (!payload.orderImage) payload.orderImage = null;
                        if (!payload.orderDeliveryContent) payload.orderDeliveryContent = null;
                        if (!payload.remark) payload.remark = null;

                        const { data: res } = await this.$http.post('campusorder/admin/createVirtualOrder', payload);
                        if (res.code === 200) {
                            this.$message.success('虚拟订单创建成功');
                            this.virtualDialogVisible = false;
                            this.resetVirtualForm();
                            this.getCategoryList();
                        } else {
                            this.$message.error(res.msg || '创建失败，请稍后重试');
                        }
                    } catch (error) {
                        console.error('create virtual order failed', error);
                        this.$message.error('创建失败，请稍后重试');
                    } finally {
                        this.virtualSubmitting = false;
                    }
                });
            },
            handleReservationDayChange() {
                this.applySelectedReservationDay();
            },
            handleNoReservationChange(checked) {
                if (checked) {
                    this.virtualForm.reservedDate = null;
                    this.virtualForm.reservedTime = null;
                    this.selectedReservationDay = '';
                    this.timeSlotOptions = [];
                } else {
                    this.prepareReservationOptions();
                }
            },
            handleSchoolChange() {
                if (this.virtualForm.noReservation) {
                    this.virtualForm.reservedDate = null;
                    this.virtualForm.reservedTime = null;
                    this.reservationDays = [];
                    this.selectedReservationDay = '';
                    this.timeSlotOptions = [];
                } else {
                    this.prepareReservationOptions();
                }
            },
            
            //点击完成订单
            updateStatus(id){
                this.$confirm('是否确定完成了此订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const {data:res}=await this.$http.get("campusorder/updateStatus",{params:{
                            id:id,//订单id
                            status:'3'
                        }})
                    console.log(res)
                    if (res.code==200){
                        this.getCategoryList();
                        this.$message.success("订单已确定完成！")
                    }else if (res.code==50006){
                        this.$message.error("订单状态修改失败，请稍后再试！")
                    }else {
                        this.$message.error("服务器异常！")
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //获取所有可用学校列表
            async getSchoolList() {
                const {data: res} = await this.$http.get("school/getSchools");
                this.schoolList = lockSchoolOptions(res.data);
                if (isSchoolScoped() && getBoundSchoolId() != null) {
                    this.queryParams.schoolId = getBoundSchoolId();
                }
            },

            //预计送达时间
            expectTime(time){
                let t=new Date(time);
                return t.setMinutes(t.getMinutes()+40);
            },

            async details(rowData){
                let orders = rowData;
                orders.expectTime= this.expectTime(orders.createTime);
                
                // 如果有接单人且有学校ID，判断接单人身份类型
                if (orders.jobUserId && orders.jobUserId !== 0 && orders.schoolId) {
                    try {
                        console.log('查询接单人身份, jobUserId:', orders.jobUserId, 'schoolId:', orders.schoolId);
                        
                        // 获取该学校的负责人和兼职列表
                        const [res1, res2] = await Promise.all([
                            this.$http.get('/campusjob/getManagersBySchool', {
                                params: { schoolId: orders.schoolId }
                            }),
                            this.$http.get('/campusjob/getRunnersBySchool', {
                                params: { schoolId: orders.schoolId }
                            })
                        ]);
                        
                        console.log('负责人列表响应:', res1.data);
                        console.log('兼职列表响应:', res2.data);
                        
                        // 检查是否在负责人列表中
                        const managerList = res1.data.data || [];
                        const isManager = managerList.some(m => 
                            m.campusUserId === orders.jobUserId || 
                            m.id === orders.jobUserId ||
                            m.userId === orders.jobUserId
                        );
                        
                        if (isManager) {
                            orders.jobType = 'F'; // 负责人
                            console.log('✅ 接单人是负责人');
                            this.orderDetail = orders;
                            await this.loadPriceIncreaseRecords(orders.id);
                            this.outerVisible = true;
                            return;
                        }
                        
                        // 检查是否在兼职列表中
                        const runnerList = res2.data.data || [];
                        const isRunner = runnerList.some(r => 
                            r.campusUserId === orders.jobUserId || 
                            r.id === orders.jobUserId ||
                            r.userId === orders.jobUserId
                        );
                        
                        if (isRunner) {
                            orders.jobType = 'C'; // 兼职
                            console.log('✅ 接单人是兼职');
                            this.orderDetail = orders;
                            await this.loadPriceIncreaseRecords(orders.id);
                            this.outerVisible = true;
                            return;
                        }
                        
                        // 如果都没找到
                        console.warn('⚠️ 未能在负责人或兼职列表中找到该用户');
                        orders.jobType = null;
                    } catch (error) {
                        console.error('❌ 获取接单人身份失败:', error);
                        orders.jobType = null;
                    }
                } else {
                    orders.jobType = null; // 无接单人
                }
                
                this.orderDetail = orders;
                
                // 加载加价记录
                await this.loadPriceIncreaseRecords(orders.id);
                
                this.outerVisible = true;
            },
            
            // 加载订单加价记录
            async loadPriceIncreaseRecords(orderId) {
                try {
                    const {data: res} = await this.$http.get('/order/price-increase/list-by-order', {
                        params: { orderId: orderId }
                    });
                    
                    if (res.code === 200) {
                        this.priceIncreaseList = res.data || [];
                        // 计算累计已支付的加价金额
                        this.totalIncreaseAmount = this.priceIncreaseList
                            .filter(item => item.paymentStatus === '1')
                            .reduce((sum, item) => sum + parseFloat(item.increaseAmount || 0), 0);
                        
                        console.log('加价记录加载成功:', this.priceIncreaseList);
                        console.log('累计加价金额:', this.totalIncreaseAmount);
                    } else {
                        console.error('加载加价记录失败:', res.msg);
                        this.priceIncreaseList = [];
                        this.totalIncreaseAmount = 0;
                    }
                } catch (error) {
                    console.error('加载加价记录出错:', error);
                    this.priceIncreaseList = [];
                    this.totalIncreaseAmount = 0;
                }
            },
            
            // 关闭订单详情弹窗
            closeOrderDetail() {
                this.outerVisible = false;
                // 清空加价记录数据
                this.priceIncreaseList = [];
                this.totalIncreaseAmount = 0;
            },

            //移除订单列表
             deleteRow(id) {
                this.$confirm('此操作将永久删除角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(async ()=>{
                    const {data: res} = await this.$http.get("campusorder/delOrderById", {
                        params: {
                            id: id,
                        }
                    });
                    console.log(res)
                    if (res.code==200){
                        this.getCategoryList();
                        this.$message.success("订单移除成功！")
                    }else {
                        this.$message.error("服务器异常！")
                    }
                }).catch(()=>{
                    this.$message.info('已取消移除！')
                })
            },

            cancel(){
                this.reset();
                this.open=false;
            },
            //重置
            resetQuery(){
                this.queryParams= {
                    pageNum: 1,
                    pageSize: 10,
                    status:'',
                    orderId:'',
                    orderPhone:'',
                    schoolId: isSchoolScoped() ? getBoundSchoolId() : '',
                    beginTime:'',
                    endTime:'',
                }
                this.getCategoryList();
            },
            async exportReport() {
                this.exportLoading = true;
                try {
                    const params = { ...this.queryParams };
                    delete params.pageNum;
                    delete params.pageSize;
                    if (this.orderTime && this.orderTime.length === 2) {
                        params.beginTime = moment(this.orderTime[0]).format('YYYY-MM-DD HH:mm:ss');
                        params.endTime = moment(this.orderTime[1]).format('YYYY-MM-DD HH:mm:ss');
                    } else {
                        params.beginTime = '';
                        params.endTime = '';
                    }
                    await downloadReport(
                        this.$http,
                        '/admin/report/export/orders',
                        params,
                        '订单报表.xlsx'
                    );
                    this.$message.success('订单报表导出成功');
                } catch (error) {
                    this.$message.error(error.message || '订单报表导出失败');
                } finally {
                    this.exportLoading = false;
                }
            },
            /**
             * 获取订单列表
             * @returns {Promise<void>}
             */
            async getCategoryList() {
                if (this.orderTime){
                    this.queryParams.beginTime=this.orderTime[0];
                    this.queryParams.endTime=this.orderTime[1];
                }else {
                    this.queryParams.beginTime='';
                    this.queryParams.endTime='';
                }
                const {data: res} = await this.$http.get("campusorder/getOrderList", {params:this.queryParams});
                // console.log(res)
                this.list=res.data.children;
                this.total=res.data.total;
            },
            handleSizeChange(val) {
                this.queryParams.pageSize=val;
                this.getCategoryList();
            },
            handleCurrentChange(val) {
                this.queryParams.pageNum=val;
                this.getCategoryList();
            },
            prepareReservationOptions() {
                if (this.virtualForm.noReservation || !this.virtualForm.schoolId) {
                    this.reservationDays = [];
                    this.selectedReservationDay = '';
                    this.virtualForm.reservedDate = null;
                    this.virtualForm.reservedTime = null;
                    this.timeSlotOptions = [];
                    return;
                }
                const operatingTime = this.getOperatingTimeBySchool(this.virtualForm.schoolId);
                const days = [];
                const today = this.buildReservationDay('today', operatingTime);
                if (today) {
                    days.push(today);
                }
                const tomorrow = this.buildReservationDay('tomorrow', operatingTime);
                if (tomorrow) {
                    days.push(tomorrow);
                }
                this.reservationDays = days;
                const defaultDay = days.find(day => !day.disabled) || days[0] || null;
                this.selectedReservationDay = defaultDay ? defaultDay.key : '';
                this.applySelectedReservationDay();
            },
            applySelectedReservationDay() {
                if (this.virtualForm.noReservation) {
                    this.virtualForm.reservedDate = null;
                    this.virtualForm.reservedTime = null;
                    this.timeSlotOptions = [];
                    return;
                }
                const selectedDay = this.reservationDays.find(day => day.key === this.selectedReservationDay);
                if (!selectedDay) {
                    this.virtualForm.reservedDate = null;
                    this.virtualForm.reservedTime = null;
                    this.timeSlotOptions = [];
                    return;
                }
                this.virtualForm.reservedDate = selectedDay.date;
                this.virtualForm.reservedTime = null;
                this.timeSlotOptions = selectedDay.disabled ? [] : selectedDay.slots;
            },
            buildReservationDay(key, operatingTime) {
                const baseDate = new Date();
                if (key === 'tomorrow') {
                    baseDate.setDate(baseDate.getDate() + 1);
                }
                const dateStr = moment(baseDate).format('YYYY-MM-DD');
                const labelPrefix = key === 'today' ? '今天' : '明天';
                const label = `${labelPrefix}（${moment(baseDate).format('MM月DD日')}）`;
                const { startMinutes, endMinutes } = this.parseOperatingRange(operatingTime);
                let effectiveStart = startMinutes;
                if (key === 'today') {
                    const now = new Date();
                    let current = now.getHours() * 60 + now.getMinutes();
                    current = Math.ceil((current + 30) / 30) * 30;
                    effectiveStart = Math.max(current, startMinutes);
                }
                const slots = this.buildSlots(effectiveStart, endMinutes);
                return {
                    key,
                    label,
                    date: dateStr,
                    slots: slots.map(slot => ({ label: slot, value: slot })),
                    disabled: slots.length === 0
                };
            },
            parseOperatingRange(operatingTime) {
                const range = (operatingTime || '11:00-19:30').split('-');
                return {
                    startMinutes: this.timeToMinutes(range[0] || '11:00'),
                    endMinutes: this.timeToMinutes(range[1] || '19:30')
                };
            },
            buildSlots(startMinutes, endMinutes) {
                const slots = [];
                for (let i = startMinutes; i + 30 <= endMinutes; i += 30) {
                    const slotStart = this.minutesToTime(i);
                    const slotEnd = this.minutesToTime(i + 30);
                    slots.push(`${slotStart}-${slotEnd}`);
                }
                return slots;
            },
            timeToMinutes(timeStr) {
                const [hours = '0', minutes = '0'] = (timeStr || '').split(':');
                return parseInt(hours, 10) * 60 + parseInt(minutes, 10);
            },
            minutesToTime(minutes) {
                const hrs = Math.floor(minutes / 60);
                const mins = minutes % 60;
                return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
            },
            getOperatingTimeBySchool(schoolId) {
                const school = this.schoolList.find(item => item.schoolId === schoolId);
                return school && school.operatingTime ? school.operatingTime : '11:00-19:30';
            }
        },
    }

</script>

<style scoped>
.tips-text {
    margin-left: 12px;
    color: #909399;
    font-size: 12px;
}

.avatar-uploader {
    display: inline-block;
}

.avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s;
}

.avatar-uploader >>> .el-upload:hover {
    border-color: var(--primary-color);
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    display: block;
}

.avatar {
    width: 148px;
    height: 148px;
    display: block;
    object-fit: cover;
}
</style>
